import _ from "lodash";
import { defineComponent, watch, ref } from "vue";
import { definePropType } from "@types-vue/props";
import FrameSelect from "./index.vue";
export default defineComponent({
    props: {
        visible: Boolean,
        currentFrame: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 默认值
        defaultValue: {
            type: definePropType(Array)
        },
        // 允许选中的数量
        count: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        FrameSelect: FrameSelect
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getDefaultValue = // 默认值
        function getDefaultValue() {
            var _$ref;
            if ((_$ref = props.defaultValue) === null || _$ref === void 0 ? void 0 : _$ref.length) {
                multipleSelection.value = _.cloneDeep(props.defaultValue);
            } else {
                var _$ref1;
                multipleSelection.value = (_$ref1 = props.currentFrame) === null || _$ref1 === void 0 ? void 0 : _$ref1.filter(function(item, index) {
                    return index < props.count;
                });
            }
        };
        var handleChange = function handleChange(list) {
            multipleSelection.value = list;
        };
        var submit = function submit() {
            handleClose();
            emit("submit", multipleSelection.value);
        };
        var handleClose = function handleClose() {
            emit("update:visible", false);
        };
        var multipleSelection = ref([]);
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                getDefaultValue();
            }
        }, {
            immediate: true
        });
        return {
            multipleSelection: multipleSelection,
            submit: submit,
            handleClose: handleClose,
            handleChange: handleChange
        };
    }
});
